<template>
  <div class="department-dialog-container">
    <el-dialog
      class="department-dialog-p"
      :visible.sync="dialogShow"
      destroy-on-close
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="department-dialog-top">
        <p class="tit">{{ isEdit ? '编辑部门' : '新建部门' }}</p>
        <i class="icon iconfont iconicon_close1 activeIconHover" @click="handleClose"></i>
      </div>

      <div class="department-dialog-content">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
          <el-form-item label="部门名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入" maxlength="20" clearable></el-input>
          </el-form-item>
          <el-form-item label="团队" prop="department_category_id">
            <el-cascader
              v-model="department_category_id"
              clearable
              :props="{
                value: 'department_category_id',
                label: 'name'
              }"
              :options="departmentType"
              @change="handleChosCategory"
            ></el-cascader>
            <!-- <el-select v-model="ruleForm.department_category_id" clearable placeholder="请选择">
              <el-option v-for="item in departmentType" :key="item.department_category_id" :label="item.name" :value="item.department_category_id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="部门分类" prop="parent_id">
            <el-cascader
              ref="cascader"
              :props="props"
              :options="opations"
              v-model="departments_id"
              clearable
              @change="changeValue"
              :disabled="!department_category_id.length"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="部门负责人" prop="department_administrators">
            <ul class="user-box">
              <li class="user-item" v-for="item in ruleForm.department_administrators" :key="item.user.uid">
                <Myavatar :imgUrl="item.user.user_avatar" width="28px" height="28px" :userName="item.user.realname">
                  <span>{{ item.user.realname }}</span>
                </Myavatar>
                <i class="icon iconfont iconicon_close1" @click="handleDel(item)"></i>
              </li>
              <li class="add-btn" @click="handleAdd">
                <i class="icon iconfont iconicon_enlarge"></i>
              </li>
            </ul>
          </el-form-item>
        </el-form>
      </div>

      <div class="department-dialog-footer">
        <span class="cancel text-btn-active" @click="handleClose">取消</span>
        <wf-button type="primary" :disabled="btnDisabled" @click="handldeSubmit" :loading="btnLoading">保存</wf-button>
      </div>
    </el-dialog>

    <div class="participant-list-wrap el-dialog__wrapper" v-if="visible">
      <ParticipantList
        v-model="departmentMemberList"
        :taskMemberlist="taskMemberlist"
        @confirm="handleConfirm"
        @close="handleParticipantListClose"
      ></ParticipantList>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
//api
import api from '@/services/api/department/department'
//组件
import ParticipantList from '@/views/customKeyPage/components/participant/participantList.vue'

export default  {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    departmentInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    ParticipantList
  },
  computed: {
    ...mapState('department/department', {
      departmentgroup: state => state.projectList.departmentgroup
    }),
    taskMemberlist () {
      let arr = []
      if (this.departmentgroup?.length) {
        const _list = this.departmentgroup
        for (let i = 0, len = _list.length; i < len; i++) {
          arr.push({
            realname: _list[i].name,
            children: []
          })
          for (let j = 0, len2 = _list[i].member.length; j < len2; j++) {
            arr[i].children.push({
              value: _list[i].member[j].uid,
              uid: _list[i].member[j].uid,
              label: _list[i].member[j].realname,
              realname: _list[i].member[j].realname,
              user_avatar: _list[i].member[j].user_avatar,
            })
          }
        }
      }
      return arr
    },
    // // 是否编辑状态
    // isEdit() {
    //   return this.departmentInfo.depart_id ? true : false
    // },
    // 保存按钮是否置灰
    btnDisabled() {
      return !this.ruleForm.name || !this.department_category_id.length
    },
    // 已有人员（转换格式）
    departmentMemberList() {
      let arr = []
      if (this.ruleForm.department_administrators.length) {
        this.ruleForm.department_administrators.forEach(ele => {
          arr.push({
            realname: ele.user.realname,
            user_avatar: ele.user.user_avatar,
            uid: ele.user.uid
          })
        })
      }

      return arr
    }
  },
  watch: {
  },
  data() {
    const _this = this
    return {
      btnLoading: false,
      ruleForm: {
        department_category_id: '',
        name: '',
        depart_header: '',
        parent_id: '',
        department_administrators: [],
        status: 1,
      },
      visible: false,
      taskMemberlistSelect: [],
      departmentType: [{
        name: require('@config/projectConfig').companyName,
        department_category_id: 888,
        children: []
      }],
      opations: [],
      department_category_id: [], // 团队
      departments_id: [],
      treeDataset: [
        {
          name: require('@config/projectConfig').companyName,
          depart_id: 888,
          parent_id: 999,
          children: []
        }
      ],
      rules: {
        name: [{ required: true, message: '部门名称不能为空', trigger: 'blur' }],
        department_category_id: [{ required: true, message: '团队不能为空', trigger: 'blur' }]
      },
      props: {
        lazy: true,
        value: 'depart_id',
        label: 'name',
        checkStrictly: true,
        emitPath: true,
        async lazyLoad(node, resolve) {
          // console.log(node, 111)
          const { data } = node
          let res = []
          // if (node.level === 0 && !_this.isEdit) return
          if (node.level === 0) {
            // 第一级，根据团队id获取
            const param = {
              number: 999,
              page: 1,
              level: 1,
              department_category_id: _this.ruleForm.department_category_id[1]
            }
            res = await (_this.getDepartmentFn(param))
            // _this.opations = res
            // _this.opations = _this.removeItem(res)
            resolve(res)
          } else {
            // if (data.children.length) {
            //   // console.log(data, 111)
            //   resolve([])
            // } else {
              // 根据部门分类id获取
              const param = {
                number: 999,
                page: 1,
                level: 1,
                pid:data.depart_id
              }
              res = await (_this.getDepartmentFn(param))
              resolve(res)
            // }
          }
        }
      },
    }
  },
  created() {
    if (this.isEdit) {
      const { depart_id, department_category_id, name, parent_id, status, department_header_user_info, department_administrators, department_tree } = this.departmentInfo
      this.ruleForm = { depart_id, name, parent_id, status, depart_header: department_header_user_info ? department_header_user_info.uid : '', department_administrators }

      // this.departments_id.push(888) // 先添加公司id，暂只有一个888
      // if (this.departmentInfo.department_level !== 1) {
        // level为1时，是不需要输入部门分类的
        let departmnetsTree = this.departmentInfo.department_tree.split(',')
        departmnetsTree.pop() // 删除最后一项，因为最后一项为空
        departmnetsTree = departmnetsTree.map(item => {
          return Number(item)
        })
        this.departments_id.push(...departmnetsTree)
      // }


      // 获取部门的数据
      this.ruleForm.department_category_id = department_category_id
      this.department_category_id = [888, department_category_id]

      // this.$nextTick(async () => {
      //   // 获取团队第一级参数
      //   const param = {
      //     number: 999,
      //     page: 1,
      //     level: 1,
      //     department_category_id
      //   }
      //   this.opations = await (this.getDepartmentFn(param))
      // })

    } else {
      // console.log(this.ruleForm, 111)
    }
    this.getDepartment()
    // console.log(this.departmentInfo, 111)
  },
  methods: {
    ...mapActions('department/department', ['getDepartmentUser']),
    async getDepartmentFn(param) {
      let treeModel = []
      // const param = {
      //   pid: id !== 888 ? id : 0,
      //   level: 1
      // }
      const res = await api.getDepartmentIndex(param)
      if (res) {
        const tree = (dataset) => {
          dataset.map(item => {
            if (item.children && item.children.data) {
              item.children = item.children.data
            } else {
              return
            }
            if (item.children && item.children.length > 0) {
              tree(item.children)
            }
          })
        }
        tree(res.data)
        res.data.map(item => {
          item.leaf = !(item.children_amount > 0)
        })
        treeModel = JSON.parse(JSON.stringify(res.data))
        return treeModel
      }
    },
    getDadObj(data, i) {
      const index = data.findIndex(item => item.depart_id === this.departments_id[i])
      return data[index]
    },
    getDepartment() {
      api.departmentTypeList({}).then(res => {
        this.departmentType[0].children = [...res]
      })
    },
    // 编辑状态下，部门分类去除掉自己的选项
    removeItem(list) {
      let _list = JSON.parse(JSON.stringify(list))
      if (this.isEdit) {
        const _index = _list.findIndex(item => item.depart_id === this.departmentInfo.depart_id)
        if (_index !== -1) {
          _list.splice(_index, 1);
        }
      }
      return _list
    },
    // 添加负责人
    handleAdd() {
      this.visible = true
      if (!this.departmentgroup?.length) {
        this.getDepartmentUser()
      }
    },
    handleDel(data) {
      const _index = this.ruleForm.department_administrators.findIndex(item => item.id === data.id)
      if (_index !== -1) {
        this.ruleForm.department_administrators.splice(_index, 1);
      }
    },
    handleConfirm(val) {
      let arr = []
      val.forEach(ele => {
        arr.push({
          id: ele.uid,
          user: {
            realname: ele.realname,
            user_avatar: ele.user_avatar,
            uid: ele.uid
          }
        })
      })
      this.ruleForm.department_administrators = arr
      this.visible = false
    },
    handleParticipantListClose() {
      this.visible = false
    },
    resetForm() {
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      this.departments_id = []
      this.ruleForm = {
        department_category_id: '',
        name: '',
        depart_header: '',
        parent_id: '',
        department_administrators: [],
        status: 1,
      }
    },
    handleClose() {
      this.resetForm()
      this.$emit('handleClose')
    },
    async handldeSubmit() {
      // await this.$refs.ruleForm.validate()
      this.btnLoading = true

      // 获取所属部门分类id，拿最后一项
      this.ruleForm.department_category_id = this.department_category_id[this.department_category_id.length - 1]
      // if (this.isEdit) {
      //   const _id = this.departments_id[this.departments_id.length - 1]
      //   this.ruleForm.department_category_id = _id === 888 ? 0 : _id
      // } else {
      //   this.ruleForm.department_category_id = ''
      // }

      let params = JSON.parse(JSON.stringify(this.ruleForm))
      params.parent_id = params.parent_id ? params.parent_id : 0
      params.department_administrators = []
      this.ruleForm.department_administrators.forEach(item => {
        params.department_administrators.push(item.user.uid)
      })
      if (this.isEdit) {
        api.updateDepartment(params).then(res => {
          this.$emit('complete', this.departmentInfo.parent_id)
          this.$message({ message: '部门更新成功', type: 'success' });
          this.btnLoading = false
        }).catch(err => {
          this.btnLoading = false
        })
      } else {
        api.addDepartment(params).then(res => {
          this.$emit('complete')
          this.$message({ message: '部门新增成功', type: 'success' });
          this.btnLoading = false
        }).catch(err => {
          this.btnLoading = false
        })
      }
    },
    async handleChosCategory(e) {
      if (e.length) {
        this.ruleForm.parent_id = null // 切换团队后，部门分类为空
        this.departments_id = []
        const param = {
          number: 999,
          page: 1,
          level: 1,
          department_category_id: this.department_category_id[1]
        }
        this.opations = await (this.getDepartmentFn(param))
        // this.opations = this.removeItem(this.opations)
      }
    },
    async changeValue(val) {
      const _id = val ? val[val.length - 1] : ''
      this.ruleForm.parent_id = _id ? _id : null
      // console.log(this.$refs.cascader.getCheckedNodes()[0].children[0], 111)
      // if (_id) {
      //   let currentObj = {}
      //   for (let i = 0, len = val.length; i < len; i++) {
      //     // 获取父级
      //     if (i === 0) {
      //       currentObj = this.getDadItem(this.opations, val[i])
      //     } else {
      //       // console.log(currentObj, 111)
      //       currentObj = this.getDadItem(currentObj.children, val[i])
      //       // console.log(currentObj, 1111)
      //     }
      //   }
      //   // console.log(val, currentObj, 1111)
      //   if (currentObj.children_amount && !currentObj.children.length) {
      //     // 父级有子集并且子集为空时，加载子集
      //     const param = {
      //       number: 999,
      //       page: 1,
      //       level: 1,
      //       pid: currentObj.depart_id
      //     }
      //     const res = await (this.getDepartmentFn(param))
      //     currentObj.children = res
      //   }
      // }
      // console.log(this.$refs.cascader.panel.store.appendNode, 111)
      const _node = this.$refs.cascader.getCheckedNodes()[0]
      if (!_node) return
      if (_node.data.children_amount && !_node.children.length) {
        // 父级有子集并且子集为空时，加载子集
        const param = {
          number: 999,
          page: 1,
          level: 1,
          pid: _node.data.depart_id
        }
        const res = await (this.getDepartmentFn(param))

        // 调用组件原生的插入节点方法插入子节点
        this.$refs.cascader.panel.store.appendNodes(res, _node)
        // _node.children = res
      }
    },
    getDadItem(data, id) {
      const index = data.findIndex(item => item.depart_id === id)
      // console.log(data, id, index, 111)
      return data[index]
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.department-dialog-container {
  .department-dialog-p {
    .el-dialog {
      width: 590px;
      .el-dialog__header {
        padding: 0 !important;
      }
      .el-dialog__body {
        padding: 0 !important;
        .department-dialog-top {
          width: 100%;
          padding: 16px 24px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid  rgba(32, 32, 32, .08);
          .tit {
            font-size: 18px;
            line-height: 22px;
          }
        }
        .department-dialog-content {
          .el-cascader {
            width: 100%;
          }
          .el-form {
            width: 100%;
            padding: 15px 24px 16px;
            box-sizing: border-box;
            .el-form-item {
              margin-bottom: 24px;
              &:last-child {
                margin-bottom: 0;
              }
            }
            .el-form-item__label {
              font-size: 14px;
              line-height: 20px;
              @include fontColorOpacity(.8);
              width: 100%;
              text-align: left;
            }
            .el-input {
              height: 40px;
              .el-input__inner {
                height: 40px;
                line-height: 40px;
              }
            }
            .user-box {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              .user-item {
                padding: 0 8px;
                border-radius: 4px;
                border: 1px solid rgba(32,32,32,0.16);
                margin: 0 8px 8px 0;
                display: flex;
                &:hover {
                  i {
                    display: block;
                  }
                }
                i {
                  cursor: pointer;
                  font-size: 12px;
                  margin-left: 8px;
                  display: none;
                }
              }
              .add-btn {
                cursor: pointer;
                width: 42px;
                height: 40px;
                border-radius: 4px;
                border: 1px solid rgba(32, 32, 32, .16);
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
          }
        }
        .department-dialog-footer {
          width: 100%;
          height: 64px;
          padding: 0 24px;
          box-sizing: border-box;
          border-top: 1px solid rgba(32, 32, 32, .08);
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .wf-button {
            width: 76px;
            margin-left: 24px;
          }
        }
      }
    }
  }
  .participant-list-wrap {
    z-index: 9999;
    @include bgColorOpacity(.4);
    .participant-wrap {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 9999;
      background: #fff;
    }
  }
}
</style>
